import React from 'react';
import PropTypes from 'prop-types'

import css from './MultilineInput.module.scss'

const MultilineInput = ({placeholder, value, changeHandler}) => {
  return (
    <textarea placeholder={placeholder} className={css.input} value={value} onChange={changeHandler} />
  )
}

MultilineInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  changeHandler: PropTypes.func.isRequired
}

MultilineInput.defaultProps = {
  placeholder: '',
  value: ''
}

export default MultilineInput;
